export const GET_ORDERS_IMPORTS_LIST = 'orders-imports/GET_ORDERS_IMPORTS_LIST';
export const getOrdersImportsListAction = payload => ({
	type: GET_ORDERS_IMPORTS_LIST,
	payload,
});

export const SET_ORDERS_IMPORTS_LIST = 'orders-imports/SET_ORDERS_IMPORTS_LIST';
export const setOrdersImportsListAction = payload => ({
	type: SET_ORDERS_IMPORTS_LIST,
	payload,
});

export const SET_IS_ORDERS_IMPORTS_LIST_LOADING = 'orders-imports/SET_IS_ORDERS_IMPORTS_LIST_LOADING';
export const setIsOrdersImportsListLoadingAction = payload => ({
	type: SET_IS_ORDERS_IMPORTS_LIST_LOADING,
	payload,
});

export const SET_PAGINATION = 'orders/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'orders/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
